import { useQuery } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { PanelDisclaimerSettings } from "newui/features/Rfx/Evaluation/types/panel.type";

export const DISCLAIMER_SETTINGS_KEY = "disclaimer-settings";

const fetchDisclaimerSettings = async (): Promise<PanelDisclaimerSettings> => {
	const response = await apiV2.get("/company/panel-disclaimer-settings");
	return (response.data as { data?: PanelDisclaimerSettings })?.data ?? response.data;
};

export const useDisclaimerSettings = () => {
	const { data, isLoading, error } = useQuery<PanelDisclaimerSettings>({
		queryKey: [DISCLAIMER_SETTINGS_KEY],
		queryFn: fetchDisclaimerSettings,
	});

	return { data, isLoading, error };
};
